import { createElementVNode as _createElementVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/icon-plus-hold.svg'
import _imports_1 from '@/assets/icons/icon-minus-hold.svg'


const _hoisted_1 = { class: "set-expiration-wr" }
const _hoisted_2 = { class: "expiration-title" }
const _hoisted_3 = { class: "strong" }
const _hoisted_4 = { class: "hold-input-wr" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["Modal"], {
      isOpen: $props.isOpen,
      onClose: $setup.onClose,
      classes: "without-padding height-limited"
    }, _createSlots({ _: 2 }, [
      (!_ctx.isLoading)
        ? {
            name: "content",
            fn: _withCtx(() => [
              _createVNode($setup["FormModalLayout"], {
                title: "Create Hold",
                onBack: $setup.onBack
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "button cancel",
                    onClick: $setup.onClose
                  }, "Cancel"),
                  _createElementVNode("button", {
                    class: "button default primary",
                    onClick: $setup.submit,
                    disabled: $setup.isSubmitting
                  }, _toDisplayString($setup.isSubmitting ? "Creating Hold..." : "Create Hold"), 9, _hoisted_5)
                ]),
                default: _withCtx(() => [
                  _cache[7] || (_cache[7] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "info-message" }, [
                      _createElementVNode("p", null, "Complete details of the hold below")
                    ])
                  ], -1)),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      _createVNode($setup["CreateInitialHoldForm"], {
                        showFormErrors: $setup.showFormErrors,
                        isBuilderOrChannelPartnerAdded: $setup.isBuilderOrChannelPartnerAdded,
                        onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.onFormChange($event)))
                      }, null, 8, ["showFormErrors", "isBuilderOrChannelPartnerAdded"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("button", {
                    class: "button add-purchaser",
                    onClick: $setup.onAddChannelBuilderOrPartner,
                    type: "button"
                  }, _toDisplayString($setup.addBuilderOrPartnerButtonText), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _cache[5] || (_cache[5] = _createTextVNode("Please set the duration of the Hold for", -1)),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(` Lot ${$setup.props.lot.title}`), 1)
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("p", null, "Day(s)", -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _withDirectives(_createElementVNode("input", {
                        class: "input-large input-days",
                        type: "text",
                        placeholder: 2,
                        maxlength: "2",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.expirationDate) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.expirationDate]
                      ]),
                      _createElementVNode("img", {
                        class: "input-large icon-plus",
                        src: _imports_0,
                        name: "plus",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onDaysChange($event)))
                      }),
                      _createElementVNode("img", {
                        class: "input-large icon-minus",
                        src: _imports_1,
                        name: "minus",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.onDaysChange($event)))
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["isOpen"]),
    _createVNode($setup["ConfirmInitialHoldModal"], {
      isOpen: $setup.isConfirmModalOpen,
      onConfirm: $setup.onConfirmModal,
      onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.isConfirmModalOpen = false))
    }, null, 8, ["isOpen"])
  ], 64))
}